import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import WarehouseIcon from '@mui/icons-material/Warehouse';

interface PopupProps {
  item: {
    id: number;
    title: string;
    level: number;
  };
}

const Popup: React.FC<PopupProps> = ({ item }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', padding: '16px', backgroundColor: '#F9EAEF', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
      {/* Szerkesztés: összes item.level */}
      <IconButton sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <EditIcon sx={{ marginRight: '8px', color: '#874B6D' }} />
        <Typography>Szerkesztés</Typography>
      </IconButton>

      {/* POS konfiguráció: összes item.level */}
      <IconButton sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <CreditCardIcon sx={{ marginRight: '8px', color: '#874B6D' }} />
        <Typography>POS konfiguráció</Typography>
      </IconButton>

      {/* Terület hozzáadása: item.level === 4 */}
      {item.level === 4 && (
        <IconButton sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <AddIcon sx={{ marginRight: '8px', color: '#874B6D' }} />
          <Typography>Terület hozzáadása</Typography>
        </IconButton>
      )}

      {/* Pult hozzáadása: item.level === 4 || item.level === 3 */}
      {(item.level === 4 || item.level === 3) && (
        <IconButton sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <AddIcon sx={{ marginRight: '8px', color: '#874B6D' }} />
          <Typography>Pult hozzáadása</Typography>
        </IconButton>
      )}

      {/* Raktár hozzáadása: összes item.level */}
      <IconButton sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <WarehouseIcon sx={{ marginRight: '8px', color: '#874B6D' }} />
        <Typography>Raktár hozzáadása</Typography>
      </IconButton>

      {/* NTAK integráció: item.level === 4 */}
      {item.level === 4 && (
        <IconButton sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <SettingsIcon sx={{ marginRight: '8px', color: '#874B6D' }} />
          <Typography>NTAK Integráció</Typography>
        </IconButton>
      )}

      {/* QuickR integráció: item.level === 5 */}
      {item.level === 5 && (
        <IconButton sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <SettingsIcon sx={{ marginRight: '8px', color: '#874B6D' }} />
          <Typography>QuickR Integráció</Typography>
        </IconButton>
      )}

      {/* Törlés: item.level === 2 || item.level === 3 */}
      {(item.level === 2 || item.level === 3) && (
        <IconButton sx={{ display: 'flex', alignItems: 'center' }}>
          <DeleteIcon sx={{ marginRight: '8px', color: '#874B6D' }} />
          <Typography>Törlés</Typography>
        </IconButton>
      )}
    </Box>
  );
};

export default Popup;